var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileDetail',{key:_vm.userUid,staticClass:"ptop-medium pbottom-medium",attrs:{"user-uid":_vm.userUid,"focus-section":_vm.focusSection}})}
var staticRenderFns = []

export { render, staticRenderFns }